import moment from 'moment';
import {addNewLine, titleCase} from 'lib/StringUtils';
import { joinNonEmpties } from 'api/reports/util/StringUtils';
import {getIn} from 'lib/immutableObject';
import get from 'lodash/get';

export const makeCoverLetterSection = (section, userDetails, propertyDetail) => {
  const defaultLetterContent = `${moment().format('Do MMMM YYYY')}

Dear Reader,
Thank you for the opportunity to appraise your property at ${propertyDetail.singleLineAddress}

Careful consideration has been taken to provide you with an appraisal for your property in today's market conditions.

To establish a market value, I have carefully considered the premises, size, location, along with current market conditions and similar properties recently sold or currently on the market.

If you have any questions about the information outlined in this appraisal, please don't hesitate to contact me using the details below. I am happy to assist further and look forward to working with you to achieve your real estate goals.

Yours Sincerely,
`;
  const localityName = propertyDetail.localityName && titleCase(propertyDetail.localityName);
  let addressState = get(propertyDetail, 'state', '');
  addressState = addressState && addressState.toUpperCase();
  let town = get(propertyDetail, 'town', '');
  town = town && titleCase(town);
  const postcode = get(propertyDetail, 'postcode');
  const locationAddress = joinNonEmpties([
    localityName,
    town,
    addressState,
    postcode,
  ], ' ') || '';
  const defaultToAddressContent = `The Proprietor\n${titleCase(propertyDetail.addressStreet)}\n${locationAddress}\n`;
  const suburbAddress = joinNonEmpties([userDetails.suburb, userDetails.state, userDetails.postalCode]);
  const mobile = userDetails.workMobileNumber && `m: ${userDetails.workMobileNumber}`;
  const email = userDetails.email;
  const sectionAddress = [
    `${userDetails.firstName} ${userDetails.lastName}`,
    userDetails.tradeName,
    userDetails.address1,
    userDetails.address2,
    suburbAddress,
    mobile,
    email,
  ].join('\n');

  let fromAddress = (section?.sectionData?.fromAddress ? section.sectionData.fromAddress : sectionAddress)
      ?.split('\n')
      ?.filter(line => line.trim() !== '') // Remove empty lines
      ?.join('\n');

  let letterContent = (section.sectionData && section.sectionData.letterContent)
    || getIn(section, ['sectionData', 'savedLetterContent'])
    || defaultLetterContent;
  let toAddress = section.sectionData && section.sectionData.toAddress ? section.sectionData.toAddress : defaultToAddressContent;

  // jasper requires new line to calculate field height
  fromAddress = addNewLine(fromAddress);
  toAddress = addNewLine(toAddress);
  letterContent = addNewLine(letterContent);
  return {
    name: 'COVER_LETTER',
    data: {
      fromAddress,
      letterContent,
      toAddress,
    }
  };
};